import React, { useState } from 'react'
import { Panel, TextFieldIcon, SelectFieldIcon, PhoneFieldIcon, FileFieldIcon, ModalComponent } from '../../_components'
import { FaBuilding, FaAddressCard, FaHourglassEnd,} from 'react-icons/fa'
import data from '../../fixtures'
import { setDisplayModal, setEducationQualCounter, setEmployeeQualificationsCounter, setSectionAData } from '../../_slices/AppSlice'
import { useSelector, useDispatch } from 'react-redux'
import { CircularProgress } from '@material-ui/core'
import Axios from 'axios'
import moment from 'moment'

export default function SectionA( { handleChange, handleBlur, values, signing, EducationFiles, setEducationFiles } ) {
    const dispatch = useDispatch()
    const state = useSelector( state => {
        return {
            educationList: state.application.educationList,
            employeeList: state.application.employeeList,
            educationQualCounter: state.application.educationQualCounter,
            employeeQualificationsCounter: state.application.employeeQualificationsCounter,
            sectionAData: state.application.sectionAData
        }
    } )
    const [ phone, setPhone ] = useState( "" )
    const [ secondaryPhone, setSecondaryPhone ] = useState( "" )
    const [ addSecondContact, setAddSecondContact] = useState(false)
    const [ checkTinVerification, setCheckTinVerification] = useState(true)
    const [ circularLoading, setCircularLoading ] = useState( false )

    // const handleFiles = async ( evt ) => {
    //     setEducationFiles( [ ...EducationFiles, 
    //         { [evt.target.name]: evt.target.files[ 0 ] } 
    //     ])
    // }

    //updated by supplied NIN
    const [surname, setSurname] = useState("");
    const [middle_name, setMiddleName] = useState("");
    const [given_name, setlGivenName] = useState("");

    //updated by supplied BRN
    const [entity_name, setEntityName] = useState("");
    const [doc, setDateOfIncorporation] = useState("");
    const [entity_type, setEntityType] = useState("");

    const handleNinBlur = async ( event ) => {
        const userInputNIN = event.target.value;
        dispatch( setSectionAData( {...state.sectionAData, nin: userInputNIN} ) );

        try {
            const response = await Axios.get(process.env.REACT_APP_API_URL+`/api/auth/person_details/${userInputNIN}`);
      
            if( response.data.return.transactionStatus.transactionStatus === "Ok" ) {
                
                let surname = response.data.return.surname
                let givenNames = response.data.return.givenNames
                let maidenNames = response.data.return.maidenNames
                let dateOfBirth = response.data.return.dateOfBirth
                let gender = response.data.return.gender
                let nationality = response.data.return.nationality
                let maritalStatus = response.data.return.maritalStatus
                let addressLine1 = response.data.return.addressLine1
                let addressLine2 = response.data.return.addressLine2
                let addressLine3 = response.data.return.addressLine3
                let livingStatus = response.data.return.livingStatus

                await setSurname(surname)
                await setMiddleName(maidenNames)
                await setlGivenName(givenNames)

                //update the redux state
                await dispatch( setSectionAData( {...state.sectionAData, surname:surname} ) );
                await dispatch( setSectionAData( {...state.sectionAData, middleName:maidenNames} ) );
                await dispatch( setSectionAData( {...state.sectionAData, firstName:givenNames} ) );
            } else{
                //console.log(response)
                alert("The Nation ID Number is incorrect. Please try again")
            }
        } catch (error) {
            console.log(error)
            alert("Oops, please make sure that the supplied NIN is valid.")
        }
    }

    const handleBusinessRegistrationNumberBlur = async ( event ) => {
        const userInputBRN = event.target.value;
        dispatch( setSectionAData( {...state.sectionAData, brn: userInputBRN} ) );

        try {
            const response = await Axios.get(process.env.REACT_APP_API_URL+`/api/auth/business_registration_details/${userInputBRN}`);
            //console.log(response.data);
      
            if( response.data.error_code !== "ENTITY_NOT_FOUND" ) {
                console.log(response.data)
                //let certificationNumber = response.data.cert_number
                let entityName = response.data.entity_name
                let companyType = response.data.company_type
                //let companySubType = response.data.company_subtype
                //let incorporationDateArray = response.data.incorporation_date //this is an array
                //let ownersTaxPayerTinsArray = []//response.data.list_owners_partners.tax_payer_tin
                let registrationDate = response.data.reg_date
                let formattedRegistrationDate = moment(registrationDate).format("YYYY-MM-DD");

                await setEntityName(entityName)
                await setDateOfIncorporation(formattedRegistrationDate)
                await setEntityType(companyType)

                //update the redux state here
                dispatch( setSectionAData( {...state.sectionAData, entity_name: entityName} ) );
            } else{
                //console.log(response)
                alert("The Business Registration Number is incorrect. Please try again")
            }
        } catch (error) {
            console.log(error)
            alert("Oops, please make sure that the supplied BRN is valid")
        }
    }

    const VerifyTin = async ( event ) => {
        const userInputTIN = state.sectionAData.tin;
        console.log("verifying tin == "+userInputTIN)
        setCircularLoading(true)

        try {
            const response = await Axios.get(process.env.REACT_APP_API_URL+`/api/auth/tin_registration_details/${userInputTIN}`);
      
            if( response.data.ErrorCode === "E000" ) {
                // the TIN seems good so set the value for the legal name of applicant
                console.log(response.data)
                dispatch( setSectionAData( {...state.sectionAData, taxPayerName: response.data.TaxPayerName} ) );
                let ursbName = state.sectionAData.entity_name.toUpperCase();
                let  cleanedUrsb = ursbName.replace(/LTD/g, "");
                cleanedUrsb = cleanedUrsb.replace(/LIMITED/g,"");
                cleanedUrsb = cleanedUrsb.replace(/-/g," ");
                cleanedUrsb = cleanedUrsb.replace(/[()]/g, '');

                let uraName = response.data.TaxPayerName.toUpperCase();
                let  cleanedUra = uraName.replace(/LTD/g, "");
                cleanedUra = cleanedUra.replace(/LIMITED/g, "");
                cleanedUra = cleanedUra.replace(/-/g, " ");
                cleanedUra = cleanedUra.replace(/[()]/g, '');

                if(cleanedUrsb !== cleanedUra){
                    alert("TIN details do not match with the entity details from URSB")
                    setCircularLoading(false)
                    setCheckTinVerification(true)
                    return;
                }

                alert("TIN details match with the entity details from URSB. Click Next to continue")

                //update the redux value for tin verification status
                dispatch( setSectionAData( {...state.sectionAData, tinVerificationStatus: true} ) );

                setCheckTinVerification(false)
                setCircularLoading(false)
            } else{
                console.log(response.data.ErrorDesc)
                alert(response.data.ErrorDesc)
                setCircularLoading(false)
                setCheckTinVerification(true)
            }
        } catch (error) {
            console.log(error)
            alert("Oops, something went wrong while checking your TIN.")
        }
    }

    const VerifyTinIndividual = async ( event ) => {
        const userInputTIN = state.sectionAData.tin;
        console.log("verifying tin == "+userInputTIN)
        setCircularLoading(true)

        try {
            const response = await Axios.get(process.env.REACT_APP_API_URL+`/api/auth/tin_registration_details/${userInputTIN}`);
      
            if( response.data.ErrorCode === "E000" ) {
                // the TIN seems good so set the value for the legal name of applicant
                console.log(response.data)
                dispatch( setSectionAData( {...state.sectionAData, taxPayerName: response.data.TaxPayerName} ) );
                if(state.sectionAData.surname.toUpperCase() !== response.data.TaxPayerName.toUpperCase()){
                    alert("TIN details do not match with the entity details from NIRA")
                    setCircularLoading(false)
                    setCheckTinVerification(true)
                    return;
                }

                alert("TIN details match with the entity details from NIRA. Click Next to continue")

                //update the redux value for tin verification status
                dispatch( setSectionAData( {...state.sectionAData, tinVerificationStatus: true} ) );

                setCheckTinVerification(false)
                setCircularLoading(false)
            } else{
                console.log(response.data.ErrorDesc)
                alert(response.data.ErrorDesc)
                setCircularLoading(false)
                setCheckTinVerification(true)
            }
        } catch (error) {
            console.log(error)
            alert("Oops, something went wrong while checking your TIN.")
        }
    }

    const handleTaxIdentificationNumberBlur = async ( event ) => {
        const userInputTIN = event.target.value;        
        dispatch( setSectionAData( {...state.sectionAData, tin: userInputTIN} ) );
    }

    const handleChangeApplicantCategory = async (evt) => {
        await dispatch( setSectionAData( {...state.sectionAData, applicantCategory: evt.target.value} ) );
    }

    const handleChangeIndividualNationality = async (evt) => {
        await dispatch( setSectionAData( {...state.sectionAData, nationality: evt.target.value} ) );
        if(evt.target.value !== "Ugandan"){
            //if not ugandan then manually bypass the tin validation
            dispatch( setSectionAData( {...state.sectionAData, tinVerificationStatus: true} ) );
            setCheckTinVerification(false)
        } else{
            dispatch( setSectionAData( {...state.sectionAData, tinVerificationStatus: false} ) );
            setCheckTinVerification(true)
        }
    }
    
    const handleChangeEntityRegistration = async (evt) => {
        await dispatch( setSectionAData( {...state.sectionAData, entity_registration: evt.target.value} ) );
        if(evt.target.value !== "Yes"){
            //if not ugandan then manually bypass the tin validation
            dispatch( setSectionAData( {...state.sectionAData, tinVerificationStatus: true} ) );
            setCheckTinVerification(false)
        } else{
            dispatch( setSectionAData( {...state.sectionAData, tinVerificationStatus: false} ) );
            setCheckTinVerification(true)
        }
    }

    const handleBlurEntityName = async (evt) => {
        await dispatch( setSectionAData( {...state.sectionAData, entity_name: evt.target.value} ) );
    }
    
    const handleChangePassport = async (evt) => {
        await dispatch( setSectionAData( {...state.sectionAData, passport_number: evt.target.value} ) );
    }

    const handleChangeSurname = async (evt) => {
        await dispatch( setSectionAData( {...state.sectionAData, surname: evt.target.value} ) );
    }

    const handleChangeMiddleName = async (evt) => {
        await dispatch( setSectionAData( {...state.sectionAData, middleName: evt.target.value} ) );
    }

    const handleChangeFirstName = async (evt) => {
        await dispatch( setSectionAData( {...state.sectionAData, firstName: evt.target.value} ) );
    }

    const handleChangeDateOfIncorporation = async (evt) => {
        await dispatch( setSectionAData( {...state.sectionAData, dateOfIncorporation: evt.target.value} ) );
    }

    const handleChangeEntityType = async (evt) => {
        await dispatch( setSectionAData( {...state.sectionAData, entityType: evt.target.value} ) );
    }

    const handleChangeContactFirstName = async (evt) => {
        await dispatch( setSectionAData( {...state.sectionAData, contact_first_name: evt.target.value} ) );
    }

    const handleChangeContactMiddleName = async (evt) => {
        await dispatch( setSectionAData( {...state.sectionAData, contact_middle_name: evt.target.value} ) );
    }

    const handleChangeContactLastName = async (evt) => {
        await dispatch( setSectionAData( {...state.sectionAData, contact_last_name: evt.target.value} ) );
    }

    const toggleSecondContactCheckbox = (evt) => {
        setAddSecondContact(!addSecondContact)
    }

    const maxDate = () => {
        var today = new Date();
        var day=today.getDate()>9?today.getDate():"0"+today.getDate(); // format should be "DD" not "D" e.g 09
        var month=(today.getMonth()+1)>9?(today.getMonth()+1):"0"+(today.getMonth()+1);
        var year=today.getFullYear();
        var max_date = year + "-" + month + "-" + day;
        return max_date;
    }

    return (
    <>
        <Panel label={`Section A: Particulars of the Applicant - ${values.category?.toUpperCase()}`}>
            <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-2">
                <SelectFieldIcon 
                    spaced
                    name="category"
                    handleChange={evt => {
                        handleChange(evt)
                        handleChangeApplicantCategory( evt)
                    }}
                    handleBlur={handleBlur}
                    value={values.category}
                    iconComponent={<FaBuilding color={`#AFC836`} />} 
                    label="Applicant Category"
                    required={true}
                    disabled={signing}
                    options={data.categories.map( item => {
                    return { id: item.id, label: item.label, value: item.value }
                    } )}
                    question="Applicant Category" />

                {values.category === "Individual"  && <SelectFieldIcon 
                    spaced
                    name="gender"
                    handleChange={evt => {
                        handleChange(evt)
                    }}
                    handleBlur={handleBlur}
                    value={values.gender}
                    iconComponent={<FaBuilding color={`#AFC836`} />} 
                    label="Gender"
                    required={true}
                    disabled={signing}
                    options={[ 
                        { id: 1, value: "Male", label: "Male" },
                        { id: 2, value: "Female", label: "Female" }
                    ]}
                    question="Gender" />}
            </div>
        </Panel>
        {values.category === "Individual"  && (
            <>
                <Panel label={`Section A: Particulars of the Applicant - ${values.category?.toUpperCase()}`}>
                    <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-2">
                        <SelectFieldIcon 
                            name="nationality"
                            handleChange={evt => {
                                handleChange(evt)
                                handleChangeIndividualNationality( evt)
                            }}
                            handleBlur={handleBlur}
                            value={values.nationality}
                            iconComponent={<FaBuilding color={`#AFC836`} />} 
                            label="Nationality"
                            required={values.category === "Individual" ? true : false}
                            disabled={signing}
                            options={data.nations.map( (item, index) => {
                            return { id: item.nationality, label: item.nationality, value: item.nationality }
                            } )}
                            question="Nationality" /> 

                        { values.nationality === "Ugandan" &&
                        ( <TextFieldIcon 
                            name="national_id"
                            handleChange={evt => {
                                handleChange(evt)
                            }}
                            handleBlur={handleNinBlur}
                            value={values.national_id}
                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                            label="NIN"
                            required={values.nationality === "Ugandan" ? true : FaHourglassEnd}
                            disabled={signing}
                            question="National ID Number( NIN )" />
                        ) }
                        { values.nationality !== "Ugandan" &&
                        ( <TextFieldIcon 
                            name="passport_number"
                            handleChange={evt => {
                                handleChange(evt)
                                handleChangePassport( evt)
                            }}
                            handleBlur={handleBlur}
                            value={values.passport_number}
                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                            label="Passport Number"
                            required={ values.nationality !== "Ugandan"? true : false}
                            disabled={signing}
                            question="Passport Number" />
                        ) }
                    </div>
                    <div className="grid grid-cols-1 gap-2 md:grid-cols-3 lg:grid-cols-3">
                        <TextFieldIcon 
                            name="surname"
                            handleChange={evt => {
                                handleChange(evt)
                                handleChangeSurname( evt)
                            }}
                            handleBlur={handleBlur}
                            value={values.surname || surname}
                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                            label="Surname"
                            required={values.category === "Individual" ? true : false}
                            disabled={signing}
                            question="Surname / Last Name" />
                        <TextFieldIcon 
                            name="middle_name"
                            handleChange={evt => {
                                handleChange(evt)
                                handleChangeMiddleName( evt)
                            }}
                            handleBlur={handleBlur}
                            value={values.middle_name || middle_name}
                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                            label="Middle Name"
                            required={values.category === "Individual" && false}
                            disabled={signing}
                            question="Middle Name" />
                        <TextFieldIcon 
                            name="given_name"
                            handleChange={evt => {
                                handleChange(evt)
                                handleChangeFirstName( evt)
                            }}
                            handleBlur={handleBlur}
                            value={values.given_name || given_name}
                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                            label="First Name"
                            required={values.category === "Individual" ? true : false}
                            disabled={signing}
                            question="Given Name / First Name" />
                        
                        <TextFieldIcon 
                            name="tin"
                            handleChange={evt => {
                                handleChange(evt)
                            }}
                            handleBlur={handleTaxIdentificationNumberBlur}
                            value={values.tin}
                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                            label="T.I.N"
                            required={values.category === "Individual" ? true : false}
                            disabled={signing}
                            question="Tax Identification Number" />

                        <div className="flex-col mt-6">
                            {circularLoading ? (
                                <div className="flex items-center justify-center">
                                    <CircularProgress size={24} color="primary" />
                                </div>
                            ):
                            (
                                <>
                                    { checkTinVerification && <button className="bg-blue-500 hover:bg-blue-400 text-white font-bold py-1 px-2 border-b-4 border-blue-700 hover:border-blue-500 text-xs rounded" type="button" onClick={VerifyTinIndividual}>
                                        {`Verify TIN To Continue`}
                                    </button>}
                                </>
                            )}
                        </div>
                    </div>
                </Panel> 
                
                <Panel label="Academic Qualifications">
                    {state.educationQualCounter < 5  && 
                       <button className="text-xs bg-blue-700 text-white px-2 py-1" type="button" onClick={() => {dispatch( setDisplayModal( { flag: true, title: "Education" } ) ); dispatch ( setEducationQualCounter(1))}}>
                            {`Add A New Qualification`}
                        </button>}
                    
                    <div className="grid grid-cols-1">
                        <table className="w-full border">
                            <thead className="text-xs bg-gray-200 font-bold p-2">
                                <th className="p-2">#</th>
                                <th>Qualification</th>
                                <th>Year of Completion</th>
                                <th>Issuing Institution</th>
                                <th>Field of Study</th>
                                <th>Attachments</th>
                            </thead>
                            <tbody>
                                {state.educationList.filter( item => item.qualification !== null ).map( ( item, index ) => {
                                    return (
                                        <tr className="text-xs p-2 text-center">
                                            <td className="p-2">{`${index+1}`}</td>
                                            <td>{item.qualification}</td>
                                            <td>{item.year_completion}</td>
                                            <td>{item.institution}</td>
                                            <td>{item.degree_type}</td>
                                            <td>{item.attachment}</td>
                                        </tr>
                                    )
                                } )}
                            </tbody>
                        </table>
                    </div>
                </Panel>
            </>
        ) }

        {/* for organisations  */}
        {values.category === "Company"  && (
            <>
                <Panel label={`Section A: Particulars of the Applicant - NON-INDIVIDUAL`}>
                    <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-2">
                        <SelectFieldIcon 
                            name="entity_registration"
                            handleChange={evt => {
                                handleChange(evt)
                                handleChangeEntityRegistration( evt)
                            }}
                            handleBlur={handleChangeEntityRegistration}
                            value={values.entity_registration}
                            iconComponent={<FaBuilding color={`#AFC836`} />} 
                            label="Registration Status"
                            required={values.category === "Company" ? true : false}
                            disabled={signing}
                            options={data.choices.map( item => {
                            return { id: item.id, label: item.label, value: item.value }
                            } )}
                            question="Is the entity registered in Uganda ?" />

                        {/* { values.entity_registration === "Yes" &&
                        (  */}<TextFieldIcon 
                            name="ern"
                            handleChange={evt => {
                                handleChange(evt)
                            }}
                            handleBlur={handleBusinessRegistrationNumberBlur }
                            value={values.ern}
                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                            label="Business Registration Number"
                            required={values.entity_registration === "Yes" ? true : false}
                            disabled={signing}
                            question="Business Registration Number( BRN )" />
                        {/* ) } */}
                        {/* { values.entity_registration === "Yes" &&
                        (  */}<TextFieldIcon 
                            name="entity_name"
                            handleChange={evt => {
                                handleChange(evt)
                                handleBlurEntityName( evt)
                            }}
                            handleBlur={handleBlurEntityName}
                            value={values.entity_name || entity_name}
                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                            label="Name"
                            required={values.entity_registration === "Yes" ? true : false}
                            disabled={signing}
                            readonly={values.entity_registration === "Yes" ? true : false}
                            question="Name of Entity" />
                        {/* ) } */}
                    </div>

                    <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-2">
                        <TextFieldIcon 
                            type="date"
                            max={maxDate}
                            name="doc"
                            handleChange={evt => {
                                handleChange(evt)
                                handleChangeDateOfIncorporation( evt)
                            }}
                            handleBlur={handleBlur}
                            value={values.doc || doc}
                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                            label="Date"
                            required={values.entity_registration === "Yes" ? true : false}
                            disabled={signing}
                            question="Date of Incorporation" />
                        <TextFieldIcon 
                            name="entity_type"
                            handleChange={evt => {
                                handleChange(evt)
                                handleChangeEntityType( evt)
                            }}
                            handleBlur={handleBlur}
                            value={values.entity_type || entity_type}
                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                            label="Entity Type"
                            required={values.entity_registration === "Yes" ? true : false}
                            disabled={signing}
                            readonly={values.entity_registration === "Yes" ? true : false}
                            question="Type of Entity" />
                        
                        <TextFieldIcon 
                            name="tin"
                            handleChange={evt => {
                                handleChange(evt)
                            }}
                            handleBlur={handleTaxIdentificationNumberBlur}
                            value={values.tin}
                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                            label="T.I.N"
                            required={true}
                            disabled={signing}
                            question="Tax Identification Number" />

                        <div className="flex-col mt-6">
                            {circularLoading ? (
                                <div className="flex items-center justify-center">
                                    <CircularProgress size={24} color="primary" />
                                </div>
                            ):
                            (
                                <>
                                    { checkTinVerification && <button className="bg-blue-500 hover:bg-blue-400 text-white font-bold py-1 px-2 border-b-4 border-blue-700 hover:border-blue-500 text-xs rounded" type="button" onClick={VerifyTin}>
                                        {`Verify TIN To Continue`}
                                    </button>}
                                </>
                            )}
                        </div>
                    </div>
                </Panel> 
            
                <Panel label="Contact Person Details">
                    <div className="grid grid-cols-1 gap-1 md:grid-cols-3 lg:grid-cols-3">
                        <TextFieldIcon 
                            name="contact_first_name"
                            handleChange={
                                evt => {
                                    handleChange(evt)
                                    handleChangeContactFirstName( evt)
                                }
                            }
                            handleBlur={handleBlur}
                            value={values.contact_first_name}
                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                            label="First Name"
                            required={values.category === "Company" ? true : false}
                            disabled={signing}
                            question="First Name( Authorised Contact Person )" />
                        
                        <TextFieldIcon 
                            name="contact_middle_name"
                            handleChange={evt => {
                                handleChange(evt)
                                handleChangeContactMiddleName( evt)
                            }}
                            handleBlur={handleBlur}
                            value={values.contact_middle_name}
                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                            label="Middle Name"
                            required={false}
                            disabled={signing}
                            question="Middle Name( Authorised Contact Person )" />
                        
                        <TextFieldIcon 
                            name="contact_last_name"
                            handleChange={evt => {
                                handleChange(evt)
                                handleChangeContactLastName( evt)
                            }}
                            handleBlur={handleBlur}
                            value={values.contact_last_name}
                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                            label="Last Name"
                            required={values.category === "Company" ? true : false}
                            disabled={signing}
                            question="Last Name( Authorised Contact Person )" />
                    </div>
                    <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-2">
                        <PhoneFieldIcon 
                            name="contact_phone_number"
                            handleChange={evt => {
                                handleChange(evt)
                                //handleChangeContactPhoneNumber( evt)
                            }}
                            handleBlur={handleBlur}
                            callback={ ( phone ) => {
                                setPhone( phone )
                                dispatch( setSectionAData( {...state.sectionAData, contact_phone_number: phone} ) );
                            } }
                            question="Phone Number( Authorised Contact Person )"
                        />

                        <div className="text-sm pt-10">
                            <input type="checkbox" name="add_second_contact" value="yes" onClick={toggleSecondContactCheckbox} /> Tick this box to add a second contact
                        </div> 
                        
                    </div>
                                       
                </Panel>

                {addSecondContact && <Panel label="Secondary Contact Person Details (Optional)">
                    <div className="grid grid-cols-1 gap-1 md:grid-cols-3 lg:grid-cols-3">
                        <TextFieldIcon 
                            name="second_contact_first_name"
                            handleChange={
                                evt => {
                                    handleChange(evt)
                                    //handleChangeContactFirstName( evt)
                                }
                            }
                            handleBlur={handleBlur}
                            value={values.second_contact_first_name}
                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                            label="First Name"
                            required={false}
                            disabled={signing}
                            question="First Name( Secondary Contact Person )" />
                        
                        <TextFieldIcon 
                            name="second_contact_middle_name"
                            handleChange={evt => {
                                handleChange(evt)
                                //handleChangeContactMiddleName( evt)
                            }}
                            handleBlur={handleBlur}
                            value={values.second_contact_middle_name}
                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                            label="Middle Name"
                            required={false}
                            disabled={signing}
                            question="Middle Name( Secondary Contact Person )" />
                        
                        <TextFieldIcon 
                            name="second_contact_last_name"
                            handleChange={evt => {
                                handleChange(evt)
                                //handleChangeContactLastName( evt)
                            }}
                            handleBlur={handleBlur}
                            value={values.second_contact_last_name}
                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                            label="Last Name"
                            required={false}
                            disabled={signing}
                            question="Last Name( Secondary Contact Person )" />
                    </div>
                    <div className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-2">
                        <PhoneFieldIcon 
                            name="second_contact_phone_number"
                            handleChange={evt => {
                                handleChange(evt)
                                //handleChangeSecondaryContactPhoneNumber( evt)
                            }}
                            handleBlur={handleBlur}
                            callback={ ( secondaryPhone ) => {
                                setSecondaryPhone( secondaryPhone )
                                dispatch( setSectionAData( {...state.sectionAData, secondary_contact_phone_number: secondaryPhone} ) );
                            } }
                            question="Phone Number( Secondary Contact Person )"
                        />
                    </div>
                </Panel>}
                
                <Panel label="Employees Academic Qualifications">
                    {state.employeeQualificationsCounter < 5  && <button className="text-xs bg-blue-700 text-white px-2 py-1" type="button" onClick={() => {dispatch( setDisplayModal( { flag: true, title: "Employees" } ) ); dispatch ( setEmployeeQualificationsCounter(1))}}>
                        {`Add A New Employee`}
                    </button>}
                    <div className="grid grid-cols-1">
                        <table className="w-full border">
                            <thead className="text-xs bg-gray-200 font-bold p-2">
                                <th className="p-2">#</th>
                                <th>Employee Name</th>
                                <th>Qualification</th>
                                <th>Year of Completion</th>
                                <th>Issuing Institution</th>
                                <th>Field of Study</th>
                                <th>Attachments</th>
                            </thead>
                            <tbody>
                                {state.employeeList.filter( item => item.employee_firstname !== undefined ).map( ( item, index ) => {
                                    
                                    return (
                                        <tr key={index} className="text-xs p-2 text-center">
                                            <td className="p-2">{`${index+1}`}</td>
                                            <td>{item.employee_firstname} {item.employee_lastname}</td>
                                            <td>{item.qualification}</td>
                                            <td>{item.year_completion}</td>
                                            <td>{item.institution}</td>
                                            <td>{item.degree_type}</td>
                                            <td>{item.attachment}</td>
                                        </tr>
                                    )
                                } )}
                            </tbody>
                        </table>
                    </div>
                </Panel>
            </>

        ) }
    </>
  )
}
